import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { ProductResponse } from 'src/app/models/product.model';
import { PurchaseResponse, PurchaseSeriesRequest, PurchaseVirtualResponse, SeriesRequest, SeriesResponse } from 'src/app/models/purchase.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { BillpayService } from 'src/app/services/billpay.service';
import { ProductService } from 'src/app/services/product.service';
import { PurchasesService } from 'src/app/services/purchases.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-history-purchases-pending',
  templateUrl: './history-purchases-pending.component.html',
  styleUrls: ['./history-purchases-pending.component.scss']
})
export class HistoryPurchasesPendingComponent {
permissionType = PermissionTypeEnum;
  startDate = '';
  endDate = '';
  type = 0;
  searchVendor = "";
  invoiceDetail: any = null;
  purchaseId: number = null;
  warehouseId: number = 0;
  warehouse = null;
  @Input() warehouseNames: { [key: number]: WarehouseResponse } = [];
  @Input() warehouseList: WarehouseResponse[] = [];
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  };
  timeout = null;

  newPurchase: PurchaseVirtualResponse;
  purchases: PurchaseVirtualResponse[] = [];

  moving: { [key: string]: boolean } = {};
  gettingProducts: { [key: string]: boolean } = {};
  loadedDetail: { [key: number]: boolean } = {};
  isAscendent = 0;
  waitingFor = null;
  warehouses = [];
  filterWarehouses = [];
  todayDate = new Date();
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  total = 0;
  showModal = false;
  currentPurchase: PurchaseVirtualResponse = null;
  warehousesById: { [key: number]: string } = {};

  changeOrder() {
    this.pagination.total.reverse();
    this.resetPagination();
  }

  ngOnInit(): void {
    this.loadWarehouses();
  }

  loadWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouseList = response.data
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        this.warehouses.forEach((warehouse) => {
          this.warehousesById[warehouse.id] = warehouse.name.toLowerCase();
        });
        this.getPurchasesPendingByIntervalDate();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  constructor(
    private toastService: ToastrService,
    private purchaseService: PurchasesService,
    private warehouseService: WarehouseService,
  ) {
    const today = new Date();
    this.endDate = getStringDate(today);
    this.startDate = getStringDate(today);
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  changeType() {
    const today = new Date();
    switch (parseInt(this.type + "")) {
      case 0:
        {
          this.endDate = getStringDate(today);
          this.startDate = getStringDate(today);
          break;
        }
      case 1:
        {
          this.endDate = getStringDate(today);
          today.setDate(today.getDate() - 7)
          this.startDate = getStringDate(today);
          break;
        }
      case 2:
        {
          this.endDate = getStringDate(today);
          today.setDate(1)
          this.startDate = getStringDate(today);
          break;
        }
      case 3:
        {
          const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

          this.startDate = getStringDate(firstDayLastMonth);
          this.endDate = getStringDate(lastDayLastMonth);
          break;
        }
      case 4:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 2);
          this.startDate = getStringDate(today);
          break;
        }
      case 5:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 3);
          this.startDate = getStringDate(today);
          break;
        }
    }
    this.getPurchasesPendingByIntervalDate();
  }

  resetModalDetailAndMove() {
    this.getPurchasesPendingByIntervalDate();
  }

  getPurchasesPendingByIntervalDate() {
    this.searchVendor = "";
    this.purchaseService.getPurchasesPendingReceiptByIntervalDate(getLongDate(this.startDate), getLongDate(this.endDate)).subscribe(
      {
        next: (response: ResponseObject) => {
          this.purchases = response.data;
          this.purchases = this.purchases.sort((a, b) => {
            if (b.date !== a.date) {
              return b.date - a.date;
            }
            return b.id - a.id;
          });

          if (this.isAscendent == 1) {
            this.purchases.reverse();
          }

          this.filterCheck();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las facturas");
        }
      }
    );
  }

  getWarehouseName(idWarehouse: number) {
    for (let i = 0; i < this.warehouses.length; i++) {
      if (idWarehouse == this.warehouses[i].id) {
        return this.warehouses[i].name;
      }
    }
    return "";
  }

  changeDate() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          this.getPurchasesPendingByIntervalDate();
        }
      }
    }
  }

  filterCheck() {
    this.pagination.total = this.purchases.filter((sale) => {
      if (this.warehouse != null) {
        if (this.warehouse != sale.warehouseData.id) {
          return false;
        }
      }
      return true;
    });

    this.pagination.total = this.pagination.total.filter((sale) => {
      return sale.number == this.searchVendor || 
      (sale.series ? sale.series : '').toLowerCase().includes(this.searchVendor.toLowerCase()) || 
      sale.providerData.name.toLowerCase().includes(this.searchVendor.toLowerCase()) || 
      (sale.providerData.nit + "").toLowerCase().includes(this.searchVendor.toLowerCase());
    });

    this.total = 0;
    this.pagination.total.forEach((sale) => {
      this.total += (sale.totalCost + sale.totalTaxes + sale.extraTax);
    });
    this.resetPagination();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.filterCheck();
  }

  verifiedInput(warehouseSelected: any) {
    var inputValue = warehouseSelected.target.value;
    clearTimeout(this.timeout);
    this.warehouseService.getWarehouseByClue(inputValue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses.filter((w) => {
          return w.id != this.invoiceDetail.warehouse;
        });
        if (this.filterWarehouses.length == 1) {
          this.inputs.warehouse.class = "fa-check";
          this.inputs.warehouse.value = this.filterWarehouses[0].name;
          this.inputs.warehouse.verified = true;
          this.inputs.warehouse.data = this.filterWarehouses[0];
        } else {
          this.inputs.warehouse.class = "fa-xmark";
          this.inputs.warehouse.verified = false;
          this.inputs.warehouse.data = null;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.inputs.warehouse.class = "fa-xmark";
        this.toastService.error(error.error.message);
        this.inputs.warehouse.verified = false;
        this.inputs.warehouse.data = null;
      }
    });
  }

  handleInput(warehouseSelected: any) {
    var inputValue = warehouseSelected.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.warehouseService.getWarehouseByClue(inputValue).subscribe({
        next: (response: ResponseObject) => {
          this.warehouses = response.data;
          this.filterWarehouses = this.warehouses.filter((w) => {
            return w.id != this.invoiceDetail.warehouse;
          });
          if (this.filterWarehouses.length > 0) {
            this.inputs.warehouse.class = "bx bx-list-check";
            this.inputs.warehouse.verified = false;
            this.inputs.warehouse.data = null;
          } else {
            this.inputs.warehouse.class = "fa-xmark";
            this.inputs.warehouse.verified = false;
            this.inputs.warehouse.data = null;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.inputs.warehouse.class = "fa-xmark";
          this.inputs.warehouse.verified = false;
          this.inputs.warehouse.data = null;
          this.toastService.error(error.error.message);
        }
      });
    }, 1000);
  }

  changeStatusInput(warehouseSelected: any) {
    this.inputs.warehouse.data = warehouseSelected;
    this.inputs.warehouse.value = warehouseSelected.name;
    this.inputs.warehouse.class = "fa-check";
    this.inputs.warehouse.verified = true;
  }

  showDetails(purchase: PurchaseVirtualResponse){
    this.purchaseId = purchase.id;
    this.currentPurchase = purchase;
    this.showModal = true;
  }

  closeModal(event: any){
    this.showModal = false;
  }

}
